/*!

=========================================================
* Material Kit PRO React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { prism } from "react-syntax-highlighter/dist/esm/styles/prism";
// core components
import ImageUpload from "components/CustomUpload/ImageUpload.js";

const codeExampleImage = `import React from 'react';
// core components
import ImageUpload from 'components/CustomUpload/ImageUpload.js';

export default function Upload(){
  return (
    <div>
      <ImageUpload />
      <ImageUpload avatar/>
    </div>
  );
}`;

const codeProps = `ImageUpload.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
  // it is a function from which you can get the files and fileNames that were uploaded
  // more can be read here: https://github.com/creativetimofficial/ct-material-kit-pro-react/issues/64
  onChange: PropTypes.func
};`;

function Upload({ ...props }) {
  //  const { } = props;
  return (
    <div>
      <h1>Upload</h1>
      <p>
        We've created two special components to make it easier for you to create
        a picture/image upload on your form.
      </p>
      <h2>Styles</h2>
      <p>
        You will find the styles for these components in
        <br />{" "}
        <code>src/assets/scss/material-kit-pro-react/_fileupload.scss</code>.
      </p>
      <h2>ImageUpload</h2>
      <p>
        This component was made to look like{" "}
        <a
          href="https://www.jasny.net/bootstrap/javascript/#fileinput?ref=creativetim"
          target="_blank"
        >
          jasny's
        </a>{" "}
        image uploads with a preview image after the user selects an image, a
        button for changing the image and one for removing it.
      </p>
      <p>
        If you want to submit the image (to save it on your server after it has
        been uploaded) you have to change the <code>handleSubmit</code> function
        in <code>src/components/CustomUpload/ImageUpload.js</code> at line 35.
      </p>
      <ImageUpload />
      <ImageUpload avatar />
      <SyntaxHighlighter language="jsx" style={prism}>
        {codeExampleImage}
      </SyntaxHighlighter>
      <h2>Props</h2>
      <SyntaxHighlighter language="jsx" style={prism}>
        {codeProps}
      </SyntaxHighlighter>
    </div>
  );
}

export default Upload;
